import React, { Component, useState, useContext } from 'react';
import ReactDOM from 'react-dom';
import { RsvpContext } from './partials/context/rootContext';
import Router from './views/router';
import { createBrowserHistory } from 'history';
import { HashRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import moment from 'moment';

import EventNav from './partials/components/eventNav';
import Footer from './partials/components/footer';


const domElement = document.getElementById('eventsApp');

if (domElement) {

    //let dataSource = window.testData;
    let dataSource = null;
    //console.log("Test Data: ", window.testData);

//    This is just for dev purposes

    if (window.pageVars) {
        dataSource = {
            //...window.testData,
            ...window.pageVars
        };
    }
//    console.log("DATA SOURCE: ", dataSource);

    

    //Initialize Google Analytics
    if(dataSource.ga_id){
        ReactGA.initialize(dataSource.ga_id, {debug: false});
        ReactGA.set({
            userId: dataSource.attendee.id,
            userRole: dataSource.attendee.title
            // any data that is relevant to the user session
            // that you would like to track with google analytics
        });
    }

    const history = createBrowserHistory();
    const firePageview = (location) => {
        const pageName = location.pathname + location.search + location.hash;
        ReactGA.set({ page: pageName }); // Update the user's current page
        ReactGA.pageview(pageName); // Record a pageview for the given page
    }
    
    //Fire a pageview for whatever page was loaded first
    firePageview(history.location);

    // Initialize google analytics page view tracking
    history.listen(location => {
        firePageview(location);
    });

    const App = () => {
        const initialRegistered = true; // dataSource.isRegistered;
        const initalRsvp = dataSource.isRSVP;
        const displayRsvp = dataSource.display_rsvp;
        const today = moment.tz('America/New_York');
        const roomsToday = dataSource.rooms.filter((room) => {return today.isSame(moment(room.start), 'day')});        
        const needsToRSVP = displayRsvp ? !initialRegistered && roomsToday.length === 0 : false;

        return (
            <RsvpContext
                initalRegisterValue={initialRegistered}
                initalRsvpValue={initalRsvp}
                initialDataSource={dataSource}
                initialSchedule={[]}
            >
                <HashRouter>
                    <EventNav data={dataSource} showLinks={initialRegistered} />
                    <Router data={dataSource} showRSVP={needsToRSVP} />
                    <Footer data={dataSource} />
                </HashRouter>
            </RsvpContext>
        );
    };

    ReactDOM.render(<App />, domElement);
}
